import { Course } from '../../../types/Course';
import { InstitutionTypeFilter } from './institutionsQueryFunction';

const fetchCourses = async (
  institutionId?: string,
  type?: InstitutionTypeFilter
): Promise<Course[]> => {
  const searchParams = new URLSearchParams();

  if (institutionId) {
    searchParams.set('institutionId', institutionId);
  }

  if (type && type !== 'all') {
    searchParams.set('type', type);
  }

  const coursesUrl = `${process.env.REACT_APP_ESTUDI_API_URL}/estudi/web/courses${
    searchParams.toString() ? `?${searchParams.toString()}` : ''
  }`;

  try {
    const response = await fetch(coursesUrl);

    if (!response.ok) {
      throw new Error(`GET ${coursesUrl} respondió ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error(error);

    return Promise.reject(error);
  }
};

export const coursesQueryFunction = (
  institutionId?: string,
  type: InstitutionTypeFilter = 'university'
) => ({
  queryKey: ['courses', institutionId ?? 'all', type],
  queryFn: async (): Promise<Course[]> => fetchCourses(institutionId, type)
});
